<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-16 09:43:46
 * @LastEditTime: 2021-01-20 11:36:03
 * @LastEditors: daikeyi
 -->
<template>
    <div style="height:100%;" class="tabbar-router-container">

        <router-view class="tabbar-router-content"></router-view>

        <van-tabbar active-color="#EE2E50" :value="cTabIndexNew" @change="tabChanged">
            <van-tabbar-item>
                <span>首页</span>
                <div class="icon" slot="icon" slot-scope="props">
                    <img :src="props.active ? icon[0].active : icon[0].normal">
                </div>
            </van-tabbar-item>
            <van-tabbar-item>
                <span>全部商品</span>
                <div class="icon" slot="icon" slot-scope="props">
                    <img :src="props.active ? icon[1].active : icon[1].normal">
                </div>
            </van-tabbar-item>
            <van-tabbar-item>
                <span>网点</span>
                <div class="icon" slot="icon" slot-scope="props">
                    <img :src="props.active ? icon[2].active : icon[2].normal">
                </div>
            </van-tabbar-item>
            <van-tabbar-item class="cartStyle">
                <span>购物车</span>
                <div class="icon" slot="icon" slot-scope="props">
                    <img :src="props.active ? icon[3].active : icon[3].normal">
                </div>
            </van-tabbar-item>
            <van-tabbar-item>
                <span>我的</span>
                <div class="icon" slot="icon" slot-scope="props">
                    <img :src="props.active ? icon[4].active : icon[4].normal">
                </div>
            </van-tabbar-item>
        </van-tabbar>
        <!-- <wxShareLoading></wxShareLoading> -->
    </div>
</template>
<script>
import {
    mapGetters,
    // mapState,
    mapActions
} from 'vuex';

import config from '@/constant/config';
import * as types from '@/store/modules/types';
export default {
    data() {
        return {
            active: 0,
            icon: [
                {
                    active: require('../assets/img/home/downtab/home1.png'),
                    normal: require('../assets/img/home/downtab/home.png')
                },
                {
                    active: require('../assets/img/home/downtab/classification1.png'),
                    normal: require('../assets/img/home/downtab/classification.png')
                },
                {
                    active: require('@/assets/img/home/downtab/wd1.png'),
                    normal: require('@/assets/img/home/downtab/wd.png')
                },
                {
                    active: require('../assets/img/home/downtab/shoppingcart1.png'),
                    normal: require('../assets/img/home/downtab/shoppingcart.png')
                },
                {
                    active: require('../assets/img/home/downtab/membercenter1.png'),
                    normal: require('../assets/img/home/downtab/membercenter.png')
                }
            ]
        };
    },
    computed: {
        ...mapGetters(['cTabIndex', 'direction']),
        cTabIndexNew: {
            get () {
                return this.$route.meta.tabBarIndex;
            },
            set () {}

        }
    },
    esvIsTabbarContainer() {
        return true;
    },
    esvShow() {
        // this.cTabIndexNew = Number(this.commonJs.getLocalStorage('cTabIndex'));
    },
    methods: {
        ...mapActions(['setCTabIndex']),
        tabChanged(active) {
            this.cTabIndexNew = active;
            this.setCTabIndex(active);
            const url = config.tabUrl[active];
            this.$store.commit(types.APP_CTAB_INDEX, parseInt(active));
            console.log('url：' + url);
            // TODO 我不明白这里是干嘛的
            if (url === 'OPGoodlist') {
                this.ESVStorage.putSavedValue('id', '-1');
            }
            this.esvReloadPage(url);
        }
    },
    components: {
        // wxShareLoading: () => import('@/components/common/wxShareLoading')
    }
};
</script>
<style scoped lang='scss'>
.cartStyle {
    img {
        margin-left: -4px;
    }
}

.icon {
    width: 18px;
    img {
        width: 100%;
    }
}

.van-tabbar-item--active {
    color: #EE2E50 !important;
}

// .van-tabbar-item__icon img {
//     width: 100%;
// }
</style>
<style>
    .van-tabbar {
        height: 50px !important;
        padding-bottom: 0 !important;
    }
</style>
